import { render, staticRenderFns } from "./AvatarIcon.vue?vue&type=template&id=6e5fd7d8&scoped=true"
import script from "./AvatarIcon.vue?vue&type=script&lang=js"
export * from "./AvatarIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5fd7d8",
  null
  
)

export default component.exports